<template>
  <div class="container-fluid wishlist-page">
    <div class="mainbody">

      <div
        id="quickModal"
        class="modal quickModal fade"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <div class="row">
                <div class="col-md-5" v-if="modalProductData">
                  <div class="breadcum mb15">
                    <i class="fa fa-circle-o" aria-hidden="true"></i>
                    <span v-if="globalLanguage == 'EN'">{{ modalProductData.name }}</span>
                    <span v-else>{{ modalProductData.name_bn }}</span>
                  </div>
                  <div class="right-border img-max-height">
                    <img
                      v-if="changeModalGallery_image === modalProductData.featured_image"
                      v-bind:src="fileUrl + 'uploads/products/' + modalProductData.featured_image"
                      class="img-responsive"
                    />
                    <img
                      v-else
                      v-bind:src="fileUrl + 'uploads/products/' + changeModalGallery_image"
                      class="img-responsive"
                    />
                  </div>
                </div>
                <div class="col-md-7" v-if="modalProductData">
                  <h3 class="m-p-title" v-if="globalLanguage == 'EN'">
                    {{ modalProductData.name }} {{ modalProductData.strength }}
                  </h3>
                  <h3 class="m-p-title" v-else>
                    {{ modalProductData.name_bn }} {{ modalProductData.strength }}
                  </h3>
                  <div class="code">
                    Code: <b>#{{ modalProductData.id }}</b>
                  </div>
                  <div class="code">
                    Availability:
                    <span class="green-color" v-if="modalProductData.stock_quantity > 0">In Stock</span>
                    <span class="red-color" v-else>Out of Stock</span>
                  </div>
                  <div class="code mt10" v-if="modalProductData.dosages_description">
                    Type: {{ modalProductData.dosages_description }}
                  </div>
                  <div class="code" v-if="modalProductData.strength">
                    Strength: {{ modalProductData.strength }}
                  </div>
                  <div class="code" v-if="modalProductData.generic_name">
                    Generic Name: {{ modalProductData.generic_name }}
                  </div>

                  <div class="price mt5">
                    <h3 class="running base-color">
                      {{ (modalProductData.price - modalProductData.discount).toFixed(2) }}
                      &#8364;
                    </h3>
                    <span class="discounted" v-if="modalProductData.discount > 0"
                      ><span>{{ modalProductData.price.toFixed(2) }} &#8364;</span></span
                    >
                  </div>
                  <div class="quick-modal-actions">
                    <div class="quick-modal-stepper">
                      <div class="quantity mt15 clearfix">
                        <div>Quantity</div>
                        <div class="pull-left">
                          <span variant="info" @click="decrement(modalProductData.id)"
                            ><img src="@/assets/images/minus-yellow.png" width="24px"
                          /></span>
                        </div>
                        <input class="pull-left text-center" type="text" min="1" :value="quantity" readonly />
                        <div class="pull-left">
                          <span variant="info" @click="increment(modalProductData.id)"
                            ><img src="@/assets/images/plusorange.png" width="24px"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div class="quick-modal-cart-action">
                      <button
                        type="button"
                        class="btn btn-add-to-cart btn-sm mt30"
                        v-if="modalProductData.stock_quantity > 0 && globalLanguage == 'EN'"
                        @click="createCartsModal()"
                      >
                        Add to Bag
                      </button>
                      <button
                        type="button"
                        class="btn btn-add-to-cart bn btn-sm mt30"
                        v-if="modalProductData.stock_quantity > 0 && globalLanguage != 'EN'"
                        @click="createCartsModal()"
                      >
                        ব্যাগে যোগ করুন
                      </button>
                    </div>
                  </div>

                </div>
                <div class="col-md-12 pd0" v-if="modalProductData">
                  <div v-if="modalProductData.gp_image_1">
                    <hr />
                    <div class="ml15 pull-left">
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_1"
                        @click="galleryImg(modalProductData.gp_image_1)"
                      >
                        <img
                          v-bind:src="fileUrl + 'uploads/products/' + modalProductData.gp_image_1"
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_2"
                        @click="galleryImg(modalProductData.gp_image_2)"
                      >
                        <img
                          v-bind:src="fileUrl + 'uploads/products/' + modalProductData.gp_image_2"
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_3"
                        @click="galleryImg(modalProductData.gp_image_3)"
                      >
                        <img
                          v-bind:src="fileUrl + 'uploads/products/' + modalProductData.gp_image_3"
                          class="img-responsive"
                        />
                      </div>
                      <div
                        class="gallery-img"
                        v-if="modalProductData.gp_image_4"
                        @click="galleryImg(modalProductData.gp_image_4)"
                      >
                        <img
                          v-bind:src="fileUrl + 'uploads/products/' + modalProductData.gp_image_4"
                          class="img-responsive"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <ul class="nav nav-tabs m-tab-menu mt0" v-if="modalProductData.description">
                    <li class="active">
                      <a data-toggle="tab" href="#Reviews">Description</a>
                    </li>
                  </ul>
                  <div class="tab-content ml15">
                    <div id="Description" class="tab-pane"></div>
                    <div id="Reviews" class="tab-pane fade in active" style="padding-right: 15px;">
                      <br />
                      <div v-html="modalProductData.description"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="related-products-section"
                v-if="related_products && related_products.length > 0"
              >
                <hr />
                <h4 class="related-title" v-if="globalLanguage == 'EN'">
                  You May Also Like
                </h4>
                <h4 class="related-title" v-else>আপনার পছন্দ হতে পারে</h4>
                <div class="related-products-scroll">
                  <div
                    class="related-product-card"
                    v-for="rp in related_products"
                    :key="rp.id"
                    @click="viewRelatedProduct(rp.id)"
                  >
                    <div class="related-product-img">
                      <img
                        v-bind:src="fileUrl + 'uploads/products/' + rp.featured_image"
                        :alt="rp.name"
                        class="img-responsive"
                      />
                      <ProductCartControl
                        control-class="related-cart-control"
                        :product-id="rp.id"
                        :language="globalLanguage"
                        :quantity="getCartQuantity(rp.id)"
                        :in-cart="hasCartQuantity(rp.id)"
                        @add="addRelatedToCart(rp)"
                        @decrement="cartDecrement(rp.id)"
                        @increment="cartIncrement(rp.id)"
                      />
                    </div>
                    <div class="related-product-info">
                      <div class="related-product-price">
                        {{ (rp.price - rp.discount).toFixed(2) }} &#8364;
                      </div>
                      <div class="related-product-name" v-if="globalLanguage == 'EN'">
                        {{ rp.name.length > 18 ? rp.name.substring(0, 18) + '...' : rp.name }}
                      </div>
                      <div class="related-product-name" v-else>
                        {{ rp.name_bn.length > 18 ? rp.name_bn.substring(0, 18) + '...' : rp.name_bn }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wishlist-empty-state" v-if="wishlist.length < 1">
        <div class="wishlist-empty-card">
          <div class="wishlist-empty-icon">
            <img src="@/assets/images/icons/noproduct.png" alt="No Product Found" />
          </div>
          <h2 v-if="language == 'EN'">Your wishlist is empty</h2>
          <h2 v-else>আপনার পছন্দের তালিকা খালি</h2>
          <p v-if="language == 'EN'">
            Save your favorite products here and come back when you are ready to order.
          </p>
          <p v-else>
            আপনার পছন্দের পণ্যগুলো এখানে রাখুন এবং অর্ডার করার সময় আবার দেখুন।
          </p>
          <router-link to="/" class="wishlist-empty-action" v-if="language == 'EN'">
            Start Shopping
          </router-link>
          <router-link to="/" class="wishlist-empty-action" v-else>
            কেনাকাটা শুরু করুন
          </router-link>
        </div>
      </div>

      <div class="products-list" v-else>
        <div
          class="col-lg-3 col-md-3 col-sm-4 col-xs-6 col-lg-custom-5 col"
          v-for="(product, index) in wishlist"
          :key="product.id"
        >
          <div
            class="product"
            v-bind:class="{ outStock: product.stock_quantity < 1 }"
          >
            <div class="discount-ribbon" v-if="product.discount > 0">
              {{ product.discount }} &#8364; <i> OFF</i>
            </div>
            <div class="img-fix-area">
              <div class="wishlist-toggle active" @click="removeFromWishlist(product)">
                <i class="fa fa-heart"></i>
              </div>

                <img
                  v-if="product.featured_image"
                  v-bind:src="fileUrl + 'uploads/products/' + product.featured_image"
                  :alt="product.name"
                  class="img-responsive"
                  style="cursor:pointer;"
                  @click="addOrIncrementCart(index, product.id)"
                />

            </div>
            <div class="summary">
              <div class="price">
                <span class="running">
                  {{ (product.price - product.discount).toFixed(2) }} &#8364;
                </span>
                <span class="discounted" v-if="product.discount > 0">
                  {{ product.price.toFixed(2) }} &#8364; </span
                >
                <span v-else>&nbsp;</span>
              </div>
              <h3 class="name" v-if="globalLanguage == 'EN'" @click="quickView(index)" data-toggle="modal" data-target="#quickModal" style="cursor:pointer;">

                  {{ product.name.length > 20 ? product.name.substring(0, 20) + '...' : product.name }}

              </h3>
              <h3 class="name bn" @click="quickView(index)" data-toggle="modal" data-target="#quickModal" style="cursor:pointer;" v-else>

                  {{ product.name_bn.length > 20 ? product.name_bn.substring(0, 20) + '...' : product.name_bn }}
                  {{ product.strength }}

              </h3>
              <div class="weight">
                {{ product.unit_quantity }} {{ product.unit }}
              </div>

              <ProductCartControl
                v-if="product.stock_quantity > 0"
                control-class="wishlist-cart-control"
                :product-id="product.id"
                :language="globalLanguage"
                :quantity="getCartQuantity(product.id)"
                :in-cart="hasCartQuantity(product.id)"
                @add="createCarts(index, product.id)"
                @decrement="cartDecrement(product.id)"
                @increment="cartIncrement(product.id)"
              />
              <div class="button-label" v-else></div>
            </div>
          </div>
        </div>
      </div>

            <CartData
        :carts="carts"
        :sum-cart-total="sum_cart_total || 0"
        :file-url="fileUrl"
        :global-language="globalLanguage"
        @remove-cart-item="removeCartItem"
        @cart-increment="cartIncrement"
        @cart-decrement="cartDecrement"
      />
    </div>
  </div>
</template>
<script>
const $ = require("jquery");
window.$ = $;
import axios from "axios";
import CartData from "./CartData";
import ProductCartControl from "./ProductCartControl";

export default {
  components: { CartData, ProductCartControl },
  data() {
    return {
      wishlist: [],
      carts: [],
      sum_cart_total: 0,
      cartsCountProduct: 0,
      language: "",
      modalProductData: null,
      changeModalGallery_image: "",
      quantity: 1,
      related_products: []
    };
  },
  created: function() {
    this.language = this.globalLanguage;
  },
  mounted() {
    this.wishlist = this.getWishlist();
    if (localStorage.getItem("carts")) {
      this.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      this.carts = [];
    }
    this.calculateCartTotal();
    this.$nextTick(() => {
      this.syncCartButtons();
    });
  },
  methods: {
    hasCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return Boolean(cart && Number(cart.cart_quantity) > 0);
    },
    getCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return cart ? cart.cart_quantity : 0;
    },
    addOrIncrementCart(index, product_id) {
      if (this.wishlist[index].stock_quantity < 1) {
        this.$toasted.show("Out of Stock. Not Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
        return;
      }
      let exists = this.carts.findIndex(obj => obj.product_id == product_id) !== -1;
      if (exists) {
        this.cartIncrement(product_id);
      } else {
        this.createCarts(index, product_id);
      }
    },
    quickView(index) {
      let vm = this;
      vm.modalProductData = this.wishlist[index];
      vm.changeModalGallery_image = this.wishlist[index].featured_image;
      let productID = vm.modalProductData.id;
      const result = this.carts.find(function(obj) {
        return obj.product_id == productID;
      });
      if (result === undefined) {
        vm.quantity = 1;
      } else {
        vm.quantity = result.cart_quantity;
      }
      vm.related_products = [];
      axios
        .get(this.globalUrl + "products/" + productID)
        .then(function(response) {
          vm.related_products = response.data.related_products;
        })
        .catch(response => {});
    },
    viewRelatedProduct(product_id) {
      let vm = this;
      const result = this.carts.find(obj => obj.product_id == product_id);
      vm.quantity = result ? result.cart_quantity : 1;
      axios
        .get(this.globalUrl + "products/" + product_id)
        .then(function(response) {
          vm.modalProductData = response.data.product;
          vm.changeModalGallery_image = response.data.product.featured_image;
          vm.related_products = response.data.related_products;
        })
        .catch(response => {
          vm.$toasted.show("Something wrong  Try again.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    addRelatedToCart(product) {
      let vm = this;
      if (product.stock_quantity < 1) {
        vm.$toasted.show("Out of Stock. Not Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
        return;
      }
      let exists = this.carts.findIndex(obj => obj.product_id == product.id) !== -1;
      if (exists) {
        this.cartIncrement(product.id);
        return;
      }
      let result = JSON.parse(localStorage.getItem("carts"));
      if (result == null) result = [];
      let price = product.price - product.discount;
      result.unshift({
        product_id: product.id,
        product_name: product.name,
        product_name_bn: product.name_bn,
        product_image: product.featured_image,
        price: price,
        image: product.featured_image,
        quantity: product.unit_quantity,
        unit: product.unit,
        cart_quantity: 1,
        stock_quantity: product.stock_quantity,
        subtotal: price * 1
      });
      localStorage.setItem("carts", JSON.stringify(result));
      vm.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      vm.$toasted.show("New Product Added In your Bag.", {
        type: "success",
        icon: "fa-check-circle",
        position: "bottom-left"
      });
    },
    increment(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex != -1) {
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if (this.quantity < stock_quantity) {
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          this.calculateCartTotal();
          this.quantity = newQuantity;
        }
      } else {
        let stock_quantity = Math.trunc(this.modalProductData.stock_quantity);
        if (this.quantity < stock_quantity) {
          this.quantity++;
        }
      }
    },
    decrement(product_id) {
      if (this.quantity === 1) {
        return;
      }
      this.quantity--;
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex != -1) {
        let oldQuantity = this.carts[objIndex].cart_quantity;
        if (oldQuantity > 1) {
          let newQuantity = oldQuantity - 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          this.calculateCartTotal();
        }
      }
    },
    createCartsModal: function() {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalProductData;
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === singleProduct.id
      );
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show("Already Added In your Bag.", {
          type: "error",
          icon: "fa-exclamation-triangle",
          position: "bottom-left"
        });
      } else {
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price = singleProduct.price - singleProduct.discount;
        if (this_product_quantity <= singleProduct.stock_quantity) {
          this_product_quantity = this_product_quantity;
        } else {
          this_product_quantity = Math.trunc(singleProduct.stock_quantity);
        }
        result.unshift({
          product_id: singleProduct.id,
          product_name: singleProduct.name,
          product_name_bn: singleProduct.name_bn,
          product_image: singleProduct.featured_image,
          price: price,
          image: singleProduct.featured_image,
          cart_quantity: this_product_quantity,
          quantity: singleProduct.unit_quantity,
          unit: singleProduct.unit,
          stock_quantity: singleProduct.stock_quantity,
          subtotal: price * this_product_quantity
        });
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        $("#product_" + singleProduct.id).addClass("cartAdded");
        $("#product_" + singleProduct.id + " .amountQuantity").text(
          this_product_quantity
        );
        this.calculateCartTotal();
        vm.$toasted.show("New Product Added In your Bag.", {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
        });
      }
    },
    galleryImg: function(image_url) {
      this.changeModalGallery_image = image_url;
    },
    removeFromWishlist: function(product) {
      this.toggleWishlist(product);
      this.wishlist = this.getWishlist();
    },
    syncCartButtons: function() {
      this.carts.forEach(function(cart) {
        $("#product_" + cart.product_id).addClass("cartAdded");
        $("#product_" + cart.product_id + " .amountQuantity").text(
          cart.cart_quantity
        );
      });
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
      for (
        var i = 0, totalSum = 0;
        i < vm.carts.length;
        totalSum += vm.carts[i++].cart_quantity
      );
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    removeCartItem: function(product_id) {
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      $("#product_" + product_id).removeClass("cartAdded");
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    createCarts: function(index, product_id) {
      let vm = this;
      let thisProductID = product_id;
      $("#product_" + product_id + " .amountQuantity").text(1);
      let check_if_cart_item_exist = this.carts.findIndex(
        x => x.product_id === this.wishlist[index].id
      );
      if (check_if_cart_item_exist >= 0) {
        $("#product_" + product_id).addClass("cartAdded");
        let objIndex = this.carts.findIndex(
          x => x.product_id === this.wishlist[index].id
        );
        let oldQuantity = this.carts[objIndex].cart_quantity;
        $("#product_" + product_id + " .amountQuantity").text(oldQuantity);
      } else {
        $("#product_" + thisProductID).addClass("cartAdded");
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null) result = [];
        let price =
          this.wishlist[index].price - this.wishlist[index].discount;
        result.unshift({
          product_id: this.wishlist[index].id,
          product_name: this.wishlist[index].name,
          product_name_bn: this.wishlist[index].name_bn,
          product_image: this.wishlist[index].featured_image,
          price: price,
          image: this.wishlist[index].featured_image,
          quantity: this.wishlist[index].unit_quantity,
          unit: this.wishlist[index].unit,
          cart_quantity: 1,
          stock_quantity: this.wishlist[index].stock_quantity,
          subtotal: price * 1
        });
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show("New Product Added In your Bag.", {
          type: "success",
          icon: "fa-check-circle",
          position: "bottom-left"
        });
      }
    },
    cartIncrement(product_id) {
      let vm = this;
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if (oldQuantity < stock_quantity) {
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#product_" + product_id).removeClass("animated");
        }, 500);
      } else {
        vm.$toasted.show(
          "<span>" +
            stock_quantity +
            "</span>" +
            "Quantity is available, Please call for more Quantity.",
          {}
        );
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#product_" + product_id + " .amountQuantity").text(newQuantity);
        $("#product_" + product_id).addClass("animated");
        setTimeout(function() {
          $("#product_" + product_id).removeClass("animated");
        }, 500);
      } else if (oldQuantity == 1) {
        this.carts = this.carts.filter(e => e.product_id !== product_id);
        $("#product_" + product_id).removeClass("cartAdded");
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      }
    }
  }
};
</script>

<style scoped>
.summary {
  padding-left: 10px;
}

.related-products-section {
  padding: 0 15px 10px;
}

.related-products-section hr {
  margin-top: 0;
}

.related-title {
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.related-products-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
}

.related-products-scroll::-webkit-scrollbar {
  height: 6px;
}

.related-products-scroll::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 6px;
}

.related-product-card {
  flex: 0 0 140px;
  width: 140px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.related-product-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.related-product-img {
  position: relative;
  height: 110px;
  padding: 8px;
}

.related-product-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.related-product-info {
  padding: 0 10px 10px;
}

.related-product-price {
  color: #f89406;
  font-weight: 600;
  font-size: 13px;
}

.related-product-name {
  font-size: 12px;
  color: #333;
  margin-top: 2px;
  line-height: 1.3;
}

</style>
